var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpiredOfferBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 306,
    viewBox: "0 0 358 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M145.802 6.85755L189.414 17.7812C197.262 19.7468 205.465 16.2935 209.544 9.30699C217.211 -3.82619 236.651 -2.31233 242.193 11.8495L266.476 73.9016C269.195 80.8505 273.422 87.1094 278.853 92.2272L348.04 157.432C366.4 174.735 354.953 205.603 329.751 206.752L322.548 207.081C302.073 208.014 291.405 231.877 304.362 247.757C320.916 268.045 299.008 296.875 275.027 286.36L241.497 271.66C232.24 267.601 221.651 267.903 212.64 272.483L156.626 300.955C135.014 311.94 108.736 300.603 101.898 277.345C99.0611 267.696 92.5833 259.528 83.834 254.568L12.8101 214.305C-10.6573 201.002 1.69893 165.077 28.3847 169.024C52.5869 172.603 66.3667 142.262 47.7458 126.393L40.3158 120.061C18.0582 101.093 37.3882 65.1758 65.4795 73.3045L99.8639 83.2543C122.478 89.7981 139.314 62.3647 123.239 45.1653C107.464 28.2871 123.392 1.24445 145.802 6.85755Z",
    fill: "url(#paint0_linear_2906_20577)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2906_20577",
    x1: 290.378,
    y1: -4.01769,
    x2: 176.519,
    y2: 254.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BED2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BED2F8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredOfferBackground);
export default __webpack_public_path__ + "static/media/expired-offer-background.26c0a4bcd22a39a2ca184450445c5518.svg";
export { ForwardRef as ReactComponent };